/** @file segmentQuad: one wire segment as the thin-instance matrix of a camera-facing unit quad. */
import { crossTo } from './crossTo';
import { matrixRows, type V3 } from './matrixRows';

/** Scratch: the segment vector, its sideways half and its midpoint (nothing is allocated per call). */
const X: V3 = [0, 0, 0];
const Y: V3 = [0, 0, 0];
const T: V3 = [0, 0, 0];

/**
 * Writes at `o` in `out` the matrix taking a unit quad to the segment `p -> q` (Babylon coordinates), `width` scene
 * units wide across it in the plane facing `back` (the view's back vector, Babylon frame).
 */
export function segmentQuad(out: Float32Array, o: number, p: V3, q: V3, back: V3, width: number): void {
  for (let c = 0; c < 3; c++) { X[c] = (q[c] ?? 0) - (p[c] ?? 0); T[c] = ((p[c] ?? 0) + (q[c] ?? 0)) / 2; }
  crossTo(Y, X, back, width);
  matrixRows(out, o, X, Y, back, T);
}
